// extracted by mini-css-extract-plugin
module.exports = {"primary":"rgb(40, 90, 132)","icon":"v_bH"};